import React from "react";
import { FormikErrors, FormikTouched } from "formik";
import { useI18n } from "@/lib/i18n/i18n_provider";
import { TextFormField } from "@/offering_v2/components/text_form_field";

export interface BookingReasonInput {
  bookingReason?: string;
}

interface BookingReasonProps {
  requireBookingReason?: boolean;
  values: BookingReasonInput;
  errors: FormikErrors<BookingReasonInput>;
  touched: FormikTouched<BookingReasonInput>;
  setFieldValue: (field: string, value: any) => void;
}

export function BookingReason(props: BookingReasonProps) {
  const { values, touched, errors, requireBookingReason, setFieldValue } =
    props;
  const { fbt } = useI18n();

  return (
    <div className="raw mb-4">
      <h3>
        {requireBookingReason
          ? fbt("bookingReasonTitle")
          : fbt("bookingReasonTitleOptional")}
      </h3>
      <TextFormField
        rows={2}
        name="bookingReason"
        value={values.bookingReason || ""}
        onChange={(value) => setFieldValue("bookingReason", value)}
        error={touched.bookingReason && errors.bookingReason}
      />
    </div>
  );
}
